import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { colors } from '@lifesize/clients.mui-components';
import { ReactComponent as SearchIcon } from '@lifesize/ux-assets/vectors/svgIcons/search.svg';
import { ReactComponent as CancelIcon } from '@lifesize/ux-assets/vectors/svgIcons/cancel.svg';
import { makeStyles, Theme } from '@material-ui/core';

interface Props {
  handleSearchChange: Function;
  intl: { formatMessage: Function };
  searchTerm: string;
}

const messages = defineMessages({
  search: { id: 'components.inCall.participantList.search', defaultMessage: 'Search' }
});

export const SearchParticipantList = ({ handleSearchChange, searchTerm, intl }: Props) => {
  const classes = useStyles({});

  return (
    <section className={classes.container}>
      <div className={classes.inputGroup}>
        <input
          autoComplete="off"
          data-testid="participant-search-input"
          maxLength={64}
          onChange={(e) => handleSearchChange(e.target.value)}
          placeholder={intl.formatMessage(messages.search)}
          type="text"
          value={searchTerm}
        />
        <SearchIcon />
        {!!searchTerm && (
          <button onClick={() => handleSearchChange()}>
            <CancelIcon data-testid="cancelIcon" />
          </button>
        )}
      </div>
    </section>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px 0`
  },
  inputGroup: {
    position: 'relative',

    '& input': {
      backgroundColor: colors.solitude,
      border: 'none',
      borderRadius: '1.2em',
      color: colors.charcoal,
      fontSize: '1.2em',
      height: '2.4em',
      padding: '0 1.8em 0 2.8em',
      width: '100%',
      '&::placeholder': {
        color: colors.charcoal,
        opacity: 1
      }
    },
    '& > svg': {
      color: colors.charcoal,
      height: '1.8em',
      left: '0.5em',
      position: 'absolute',
      top: '50%',
      transform: 'translate(0, -50%)',
      width: 'auto'
    },
    '& button': {
      alignItems: 'center',
      border: 'none',
      display: 'flex',
      height: '100%',
      justifyContent: 'center',
      padding: 0,
      position: 'absolute',
      right: 0,
      top: 0,
      width: '1.8em',
      '& svg': {
        color: colors.charcoal,
        height: '1.2em',
        width: 'auto'
      }
    }
  }
}));

export default injectIntl(SearchParticipantList);
